import React from 'react'
import { connect } from 'react-redux'
import request from 'utils/request'

import PropTypes from 'prop-types'
import BaseComponent from 'utils/BaseComponent'
import Button from 'components/Button'
import DateInput from 'components/DateInput'
import Select from 'components/Select'

import { statusChanged } from 'components/RequestStatus/actions'
import { claimChanged } from 'scenes/VehicleDetail/actions'

import { CLAIM_NEXT_ACTIVITIES } from 'constants'

import './styles.scss'

export class AddActivity extends BaseComponent {

  // Delegate method should be set to _onAccept() on props when the objected is created
  // Exameple: 
  // <ConfirmationModal _onAccept={this._delegateAcceptAction.bind(this)} match={this.props.match} />

  constructor(props) {
    super(props)
    this.state = {
      activity: null,
      activity_date: '',
      buttonProps: {
        disabled: false
      },
      errors: {
        activity: [],
        activity_date: []
      }
    }
    this._bind('_handleSubmit', '_cancelSendReport', '_renderMessage',
      '_handleChange', '_createActivity', '_fetchActivities', '_getActivity')
  }

  componentDidMount() {
    
  }

  _fetchActivities(){
    console.log("feching activities ...")
    return request(CLAIM_NEXT_ACTIVITIES(this.props.claimId))
      .then((res) => {
        console.log(res)
        const options = res.activities.map((activity) => ( { value: activity.id, label: activity.name } ))
        return { options }
      })
      .catch(console.log)
  }

  _getActivity(selectedOption){
    this.setState({
      activity: selectedOption
    })
  }

  _handleSubmit(e) {
    e.preventDefault()
    var errors = {
      activity: [],
      activity_date: []
    }
    var form_ok = true
    e.preventDefault()
    if (this.state.activity === null) {
      errors['activity'] = ['La actividad es requerida']
      form_ok = false
    }
    if (this.state.activity_date === "") {
      errors['activity_date'] = ['La fecha es requerida']
      form_ok = false
    }
    this.setState({ "errors": errors })

    if (form_ok){
      this._createActivity()
    }
  }

  _createActivity(){
    const formData = new FormData()

    formData.append('activity', this.state.activity) 
    formData.append('activity_date', this.state.activity_date)
    
    this.props.updateRequestStatus('progress', 'Creando estado ...')
    request(CLAIM_NEXT_ACTIVITIES(this.props.claim.id), {
      method: 'POST',
      isUpload: true,
      body: formData
    }).then((res) => {
      this.props.updateRequestStatus('ok', 'Estado registrado')
      // this.props.claimChanged({
      //   ...this.props.claim,
      //   sms_enabled: true
      // })
      this.props._onSuccess()
      this.context.toggleModal(false)  
      
    }).catch((err) => {
      this.props.updateRequestStatus('error', 'Error al guardar la actividad')
      this.context.toggleModal(false)  
    })

    this.setState({
      editting: false
    })
  }

  _createActivity2(){
    // const formData = new FormData()

    // formData.append('name', this.state.name)
    // formData.append('phone', this.state.phone) 

    // this.props.updateRequestStatus('progress', 'Creando estado ...')
    // request(CLAIM_POCS(this.props.claim.id), {
    //   method: 'POST',
    //   isUpload: true,
    //   body: formData
    // }).then((res) => {
    //   this.props.updateRequestStatus('ok', 'Contacto registrado')
    //   this.props.claimChanged({
    //     ...this.props.claim,
    //     sms_enabled: true
    //   })
    //   this.props._onSuccess()
    //   this.context.toggleModal(false)  
    //   // this.setState({

    //   // })
    // }).catch((err) => {
    //   this.props.updateRequestStatus('error', 'No pudimos crear el contacto')
    //   // this.props.claimChanged({
    //   //   ...this.props.claim,
    //   //   sms_enabled: true
    //   // })
    //   // this.props._onSuccess()
    //   this.context.toggleModal(false)  
    // })

    // this.setState({
    //   editting: false
    // })
  }

  _handleChange(e) {
    var value = e.target.value
    this.setState({ [e.target.name]: value })
  }

  _cancelSendReport(e){
    this.context.toggleModal(false)
  }

  _renderMessage(){
    var message = "Ingresa los datos para registrar la actividad de la cronología"
    return (
      <div className="content">
        <p className="pocTitle">{ message }</p>
      </div>
    )
  }

  render() {
    var title = "Registrar la actividad de la cronología"
    var acceptLabel = this.props.acceptLabel || "Crear estado"
    return(
      <div id="AddActivity" className="AddActivity Modal__content">
        <div className="EditModal__header d-flex justify-content-between align-items-center">
          <h1>{ title }</h1>
          <span className="material-icons close-button" onClick={this._cancelSendReport}>clear</span>
        </div>
        <form onSubmit={this._handleSubmit} className="f-flex EditModal__form">
            { this._renderMessage() }
            <div className="form-select-field-type">
                <label>Actividad *</label>
                <Select errors={this.state.errors.activity}
                  loadingPlaceholder="Buscando..."
                  loadOptions={this._fetchActivities}
                  noResultsText='Sin resultados'
                  onChange={this._getActivity}
                  placeholder="Seleccionar actividad"
                  searchPromptText="Escribe para comenzar la búsqueda"
                  value={this.state.activity}
                  isAsync={ false } />
            </div>
            <br></br>
            <div className="form-field">
              <label>Fecha *</label>
                <DateInput
                  errors={this.state.errors.activity_date}
                  name="activity_date"
                  format="DD/MM/YYYY"
                  onChange={this._handleChange}
                  value={this.state.activity_date} />
            </div>
            <br></br>
            <center>
              <Button className="button"
                  size="small"
                  buttonType="primary"
                  {...this.state.buttonProps}>{ acceptLabel }</Button>
            </center>
        </form>
        <br></br>
      </div>
    )
  }
}

AddActivity.contextTypes = {
  toggleModal: PropTypes.func.isRequired,
  secondToggleModal: PropTypes.func.isRequired
}


const mapStateToProps = (state) => {
  return {
    state: state.clientDetail.get('state').toObject(),
    location: state.clientDetail.get('location').toObject(),
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    updateRequestStatus: (status, message) => dispatch(statusChanged(status, message)),
    claimChanged: (vehicle) => dispatch(claimChanged(vehicle))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AddActivity)



// WEBPACK FOOTER //
// ./src/scenes/VehicleDetail/components/Claim/Chronology/AddActivity/index.js